import Vue from 'vue'
import Vuex from 'vuex'
import langs from './i18n/route.json'
import {
  loadLanguageAsync
} from './i18n'
import { Locale } from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import instance from './assets/js/instance'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: '',
    lanList: langs,
    login: false,
    path: '/',
    isPhone: true
  },
  getters: {
    getLanguage(state) {
      return state.language
    },
    getLanList(state) {
      return state.lanList
    },
    getPath(state) {
      return state.path
    },

    getLogin(state) {
      return state.login
    },

    getIsPhone(state) {
      return state.isPhone
    }
  },
  mutations: {
    LANGUAGE_CHANGE(state, ployed) {
      state.language = ployed.language
      loadLanguageAsync(state.language).then(() => {
        console.log('language change', ployed.language)
      })
      if (ployed.language === 'en') {
        Locale.use('en-US', enUS)
      } else {
        Locale.use('zh-CN', zhCN)  
      }
    },
    PATH_CHANGE(state, ployed) {
      state.path = ployed.path
    },

    LOGIN_CHANGE(state, ployed) {
      state.login = ployed.login
      // 全局事件广播 登录失败  处理流程
      window.subscribe.trigger('login', ployed)
    },


    ISPHONE_CHANGE(state, ployed) {
      state.isPhone = ployed.isPhone
    }
  },
  actions: {
    setLanguage({
      commit
    }, ployed) {
      commit('LANGUAGE_CHANGE', ployed)
    },

    setPath({
      commit
    }, ployed) {
      commit('PATH_CHANGE', ployed)
    },

    setLogin({
      commit
    }, ployed) {
      commit('LOGIN_CHANGE', ployed)
    },

    setIsPhone({
      commit
    }, ployed) {
      commit('ISPHONE_CHANGE', ployed)
    }
  }
})
